import { useEffect } from 'react';
import CrmTemplateBanner from 'setup-guide-components/components/banner/CrmTemplateBanner';
import { setInAppSidepanelExposure } from 'growth-in-app-sidepanel-nav/storageUtils';
import { useOnboardingSettings } from '../../hooks/config';
import { trackSectionView, trackUserInteraction } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmTemplateBannerContainer = () => {
  const {
    crmTemplate
  } = useOnboardingSettings() || {};
  useEffect(() => {
    if (crmTemplate) {
      trackSectionView('crm customizations banner', crmTemplate);
    }
  }, [crmTemplate]);
  if (!crmTemplate) {
    return null;
  }
  return /*#__PURE__*/_jsx(CrmTemplateBanner, {
    "data-test-id": "crm-template-banner",
    onClick: () => {
      trackUserInteraction('crm template banner click', crmTemplate);
      setInAppSidepanelExposure();
    }
  });
};
export default CrmTemplateBannerContainer;